export default "/Frontend/dist/image-hover.71e820a5e65958fc3a30ec103732d6a3.svg";